import { cva } from "class-variance-authority";
import Loader from "./Loader";
import { twMerge } from "tailwind-merge";

type ButtonVariant = "primary" | "outlined" | "text" | "error";

interface BasicButtonProps {
  text?: string;
  icon?: React.ReactNode;
  variant?: ButtonVariant;
  loading?: boolean;
  disabled?: boolean;
  className?: string;
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>["type"];
  onClick?: (event: React.MouseEvent) => void;
}

export default function BasicButton({
  text,
  type = "button",
  variant = "primary",
  loading,
  disabled,
  className,
  onClick,
}: BasicButtonProps) {
  return (
    <button
      type={type}
      disabled={disabled}
      className={twMerge(buttonStyles({ variant }), className)}
      onClick={onClick}
    >
      {loading ? (
        <Loader size="sm" />
      ) : (
        <p className="whitespace-nowrap">{text}</p>
      )}
    </button>
  );
}

const buttonStyles = cva(
  "relative w-fit rounded-md px-5 py-3 text-center text-sm transition-colors duration-300 font-semibold",
  {
    variants: {
      variant: {
        primary:
          "bg-slate-700 text-white hover:bg-slate-800 disabled:bg-zinc-300",
        outlined:
          "bg-white text-black border-solid hover:bg-zinc-300 border border-zinc-500 disabled:bg-zinc-300",
        text: "bg-transparent text-zinc-700 hover:text-black disabled:text-zinc-300",
        error: "bg-red-500 text-white hover:bg-red-600 disabled:bg-zinc-300",
      },
    },
    defaultVariants: {
      variant: "primary",
    },
  }
);
